import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { careerStages } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ForWhoSection() {
  return <section className="bg-mp-dark py-16 md:py-24" data-id="element-129" data-mp="2c7x196mirl7r">
      <Container data-id="element-130" data-mp="2c5atp6zmp5pj">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-131" data-mp="285s8ea3wasm6">
          <SectionTag tone="white" data-id="element-132" data-mp="287d4431y4hlm">¿Es para mí?</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-133" data-mp="2365tzxcbz6bs">
            Diseñado para diferentes momentos de tu carrera.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-134" data-mp="1t8rhu9xfx3pa">
          {careerStages.map((stage, i) => <motion.div key={stage.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i * 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-135" data-mp="3slvkkbx8hqvr" data-mpi={i}>
              <p className="font-heading text-base uppercase tracking-wide text-mp-lime" data-id="element-136" data-mp="1ic583qy5j8c2">{stage.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-137" data-mp="1nagfzw4vz8rn">{stage.copy}</p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}